import { gql } from "@apollo/client";

export default gql`
  query ForgotPasswordQuery($email: String!, $queueEmail: Boolean!, $useragent: String!, $expiresIn: String) {
    userToken(email: $email, queueEmail: $queueEmail, useragent: $useragent, expiry: $expiresIn)
  }
`;
